module.exports = __webpack_public_path__ + "static/media/golfer-3-b.716d3a31.png";